module.exports = __webpack_public_path__ + "static/media/navigateright.66178255.svg";